import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { NotificationWrapper } from '@/components/notification';
import { Button } from '@hotmart-org-ca/user-account-ui';
import { EVENT } from '@/common/constants';
import { useEventAgent } from '@/common/hooks/useEventAgent';

function TryAgain({ onRetry }: { onRetry?: () => void }) {
  const { t } = useTranslation();
  const { trackEventWithDedup } = useEventAgent();

  useEffect(() => {
    trackEventWithDedup(EVENT.NOTIFICATION_TRY_AGAIN_VIEW);
  }, []);

  const handleRetry = () => {
    trackEventWithDedup(EVENT.NOTIFICATION_ERROR_RETRY_CLICK);
    onRetry?.();
  };

  return (
    <NotificationWrapper
      title={t('notificationWarning.title')}
      help={t('notificationWarning.help')}
      status="warning"
    >
      <div className="w-full">
        {onRetry && (
          <Button color="primary" onClick={handleRetry} fullWidth>
            {t('common.button.tryAgain')}
          </Button>
        )}
      </div>
    </NotificationWrapper>
  );
}

export default TryAgain;
